// extracted by mini-css-extract-plugin
export default {"lastName":"styles_lastName__XelBE","media":"styles_media__mnH6s","ltr":"styles_ltr__Y+r7B","rtl":"styles_rtl__3-cJB"};